import React, { useState, useEffect } from 'react';
import "../Header/header.css";
import { Link, useNavigate } from 'react-router-dom';
import navContent from '../../JSONData/navbar.json';
import Logo from "../../assets/images/luminicoslogo.svg"
import { TfiClose } from "react-icons/tfi";
import axios from 'axios';
import config from '../../config';

import { IoIosArrowDown } from "react-icons/io";
export default function Navbar({ lang = 'en', project, isHomePage = false }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const [loading, setLoading] = useState(true);
  const [languages, setLanguages] = useState([]);
  const navigate = useNavigate();
  const [currentLanguage, setCurrentLanguage] = useState(lang || "en");
  const openMenu = () => setMenuOpen(true);
  const closeMenu = () => setMenuOpen(false);
  const toggleServices = () => setServicesOpen(!servicesOpen);
  const [isNavOpen, setisNavOpen] = useState(false);
  const toggleNav = () => {
    setisNavOpen(prev => !prev);
  }
  const [isOpen, setIsOpen] = useState(false);
  const labels = (navContent && navContent[currentLanguage]) ? navContent[currentLanguage] : navContent.en;
  const [services, setServices] = useState([]);

  const fetchLanguages = async () => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/admin/get-languages`, { withCredentials: true });

      if (response.data) {
        setLanguages(response.data);
      }

    } catch (err) {
      console.log('Failed to fetch languages');
    }
  };
  const fetchServices = async () => {
    try {
      const response = await axios.get(
        `${config.BASE_URL}/api/admin/services${lang ? `?lang=${lang}` : ''}`,
        { withCredentials: true }
      );
      if (response.data?.data) {
        setServices(response.data?.data);
      }
    } catch (err) {
      console.log('Failed to fetch languages');
    } finally {
      setLoading(false);
    }
  };


  // Helper: build a path with current language prefix if present
  const withLang = (path) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    if (currentLanguage) {
      const firstSegment = cleanPath.split('/')[1]?.toLowerCase();
      if (firstSegment === 'en' || firstSegment === 'es') return cleanPath; // already prefixed
      return `/${currentLanguage}${cleanPath}`;
    }
    return cleanPath;
  };

  // Detect language from URL or localStorage on first load
  useEffect(() => {
    const firstSegment = window.location.pathname.split('/')[1]?.toLowerCase();
    const storedLang = (localStorage.getItem('lang') || '').toLowerCase();
    const isAdminRoute = window.location.pathname.startsWith('/admin');

    if (firstSegment === 'es' || firstSegment === 'en') {
      setCurrentLanguage(firstSegment);
      try { localStorage.setItem('lang', firstSegment); } catch (_) { }
    } else if (!isAdminRoute && (storedLang === 'es' || storedLang === 'en')) {
      // If no lang in URL and we have a stored language, redirect to it preserving path
      const newPath = `/${storedLang}${window.location.pathname}`;
      setCurrentLanguage(storedLang);
      if (newPath !== window.location.pathname) {
        navigate(newPath, { replace: true });
      }
    } else {
      setCurrentLanguage('en');
      try { localStorage.setItem('lang', 'en'); } catch (_) { }
    }
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeLanguage = (language) => {
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split('/').filter(segment => segment !== '');

    // Remove the current language from the path if it exists
    if (pathSegments[0] === 'en' || pathSegments[0] === 'es') {
      pathSegments.shift(); // Remove the language segment
    }

    // Construct the new URL with the new language
    const newPath = `/${language}/${pathSegments.join('/')}`;
    setCurrentLanguage(language);
    try { localStorage.setItem('lang', language); } catch (_) { }
    navigate(newPath);
  }

  useEffect(() => {
    fetchLanguages();
    fetchServices()
  }, []);

  useEffect(() => {
    if (project) {
      setCurrentLanguage(project?.language?.toLowerCase());
      try { localStorage.setItem('lang', project?.language?.toLowerCase()); } catch (_) { }
    }
  }, [project]);
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

  }, [menuOpen]);

  // Close services dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (servicesOpen && !event.target.closest('.services-container')) {
        setServicesOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [servicesOpen]);

  return (
    <>
      <header className={`site-header header-dark position-absolute w-100 ${menuOpen ? 'mega-menu-open' : ''}`}>
        <div className={`top-header d-flex justify-between align-center px-20 py-15 w-100 border-bottom border-gray`}>
          <div className="left-block d-flex gap-10">
            {!menuOpen ? (
              <div onClick={openMenu} className="hamburg-menu cursor-pointer">
                <span></span>
                <span></span>
              </div>
            ) : (
              <div onClick={closeMenu} className="close-icon cursor-pointer">
                <TfiClose />
              </div>
            )}


            <div className={`border-left pl-10 border-gray language-block d-flex align-center gap-10 position-relative h-100 ${isOpen ? "open" : ""}`} onClick={() => setIsOpen(!isOpen)}>
              {currentLanguage.toString().toUpperCase()} <IoIosArrowDown />
              <ul className="ml-10 color-dark uppercase position-absolute end-0">
                {lang ? languages.length > 0 && languages.map((language, key) => (
                  <li key={key} className={currentLanguage === language?.code ? "active" : ""} onClick={() => changeLanguage(language?.code)}>{language?.code.toUpperCase()}</li>
                )) : (
                  project && (
                    <>
                      {project?.parentId !== null ? (
                        <>
                          <li className={currentLanguage === project?.parentId?.language ? "active" : ""} onClick={() => navigate(`/project/${project?.parentId?.slug}`)}>{project?.parentId?.language}</li>

                          {project?.parentId?.translations.length > 0 && project?.parentId?.translations.map((translation) => (

                            <li className={currentLanguage === translation?.code ? "active" : ""} onClick={() => navigate(`/project/${translation?.slug}`)}>{translation?.code}</li>
                          ))}
                        </>
                      ) : (
                        <>
                          <li className={currentLanguage === project?.language ? "active" : ""} onClick={() => navigate(`/project/${project?.slug}`)}>{project?.language}</li>

                          {project?.translations.length > 0 && project?.translations.map((translation) => (

                            <li className={currentLanguage === translation?.code ? "active" : ""} onClick={() => navigate(`/project/${translation?.slug}`)}>{translation?.code}</li>
                          ))}
                        </>
                      )}
                    </>
                  )
                )}
              </ul>
            </div>
          </div>
          <div className="center-block">
            <div className="site-logo">
              <Link to={withLang('/')}> <img src={Logo} alt="Site Logo" /></Link>
            </div>
          </div>
          <div className="right-block sm-hide text-right">
            <Link to={withLang('/contact-us')} className='button button-primary fw-500'>{labels.cta}</Link>
          </div>
        </div>
      </header>
      <div className={`header-mega-menu w-100 position-absolute top-0 ${menuOpen ? 'open-menu' : ''}`}>
        <div className='head-block d-flex justify-between align-center px-20 d-px-35 py-15  d-py-30 w-100 border-bottom border-gray position-relative'>
          <div className="site-logo d-ms-auto me-auto">
            <Link to={withLang('/')}> <img src={Logo} alt="Site Logo" /></Link>
          </div>
          <div onClick={closeMenu} className='close-icon cursor-pointer position-absolute'>
            <TfiClose />
          </div>
        </div>
        <div className='grid-blocks w-100 d-flex d-gap-0 gap-50 sm-flex-column justify-between px-30 d-px-110 py-40 d-py-80 color-light'>
          <div className='grid-block'>
            <div className='menu-block'>
              <ul>
                <li className='d-mb-5'><Link to={withLang('/about')} className='font-size-16 fw-200 capitalize'>{labels.menu.about}</Link></li>
                <li className='d-mb-5'><Link to={withLang('/project_index')} className='font-size-16 fw-200 capitalize'>{labels.menu.projects}</Link></li>
                <li className='d-mb-5'><Link to={withLang('/blogs')} className='font-size-16 fw-200 capitalize'>{labels.menu.news}</Link></li>

                {/* Services Subsection */}
                <div className='services-container'
                  onMouseEnter={() => setServicesOpen(true)}
                  onMouseLeave={() => setServicesOpen(false)}>
                  <li className='d-mb-5 ' onClick={toggleServices}>
                    <span className='font-size-16 fw-400 capitalize text-uppercase letter-spacing-1 cursor-pointer'>
                      {labels.menu.services.label}
                      <span className={`services-arrow ${servicesOpen ? 'open' : ''}`}>
                        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.60224 6.94085L1.04733 2.38591C0.827648 2.16623 0.827648 1.81008 1.04733 1.59042L1.57859 1.05916C1.79789 0.839859 2.15332 0.839437 2.37314 1.05823L6 4.66809L9.62684 1.05823C9.84666 0.839437 10.2021 0.839859 10.4214 1.05916L10.9526 1.59042C11.1723 1.8101 11.1723 2.16626 10.9526 2.38591L6.39776 6.94085C6.17808 7.16051 5.82192 7.16051 5.60224 6.94085Z" fill="white" />
                        </svg>

                      </span>
                    </span>
                  </li>
                  <div className={`services-dropdown ${servicesOpen ? 'open' : ''}`}>
                    <li className='d-mb-5 services-item'>
                      <Link to={withLang('/for-contractors')} className='font-size-16 fw-200 capitalize'>{labels.menu.services.contractors}</Link>
                    </li>
                    <li className='d-mb-5 services-item'>
                      <Link to={withLang('/for-architects-and-designers')} className='font-size-16 fw-200 capitalize'>{labels.menu.services.architects}</Link>
                    </li>
                    <li className='d-mb-5 services-item'>
                      <Link to={withLang('/lighting-facade')} className='font-size-16 fw-200 capitalize'>{labels.menu.services.facade}</Link>
                    </li>
                    <>
                      {services.map((service) => (
                        <li key={service._id} className='d-mb-5 services-item'>
                          <Link
                            to={`/services/${service?.slug}`}
                            className='font-size-16 fw-200 capitalize'
                          >
                            { service?.hero?.title}
                             
                          </Link>
                        </li>
                      ))}
                    </>
                  </div>
                </div>

                <li className='d-mb-5'><Link to={withLang('/contact-us')} className='font-size-16 fw-200 capitalize'>{labels.contact}</Link></li>
              </ul>
            </div>

          </div>
          <div className='grid-block'>
            <div className='summary-block text-left d-text-right'>
              <h2 className='mb-15 fw-300'>{labels.ctaTitle}</h2>
              <p className='mb-50 fw-400'>{labels.ctaSubtitle}</p>
              <Link to={withLang('/contact-us')} className='button button-primary' >{labels.cta}</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
